import pagination from 'assets/themes/campings/js/page/product/reviews/pagination'
import reviewComment from 'assets/core/js/page/product/review/comment'
import sorting from 'assets/themes/campings/js/page/product/reviews/sorting'
import toggle from 'assets/themes/campings/js/page/product/reviews/toggle'
import tripadvisor from 'assets/themes/campings/js/page/product/reviews/tripadvisor'

export default (): void => {
  const reviewsEl = document.querySelector('.product__reviews-content')

  if (!reviewsEl) {
    return
  }

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        pagination()
        reviewComment()
        sorting()
        toggle()
        tripadvisor()

        observer.unobserve(entry.target)
      }
    })
  })

  observer.observe(reviewsEl)
}
